const referralTypes = Object.freeze({
  regular: 1,
  validacion: 5,
  avaluo: 6,
  solicitudServicioRelacionadoEquipo: 7,
  solicitudServicioAsistenciaTecnica: 8,
});

export default referralTypes;
